/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { ellipsisText } from 'Styles/styles';

export const TriggerButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  font-size: 13.5px;
  line-height: ${({ variant }) => (variant === 'detail' ? 2.52 : 1.5)};
  color: ${({ variant, theme }) => (
    variant === 'table'
      ? colors.blueCerulean
      : theme.textfield.text
  )};

  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
    margin-right: auto;
    ${ellipsisText}
  `}
`;
TriggerButton.displayName = 'TriggerButton';
